<div class="modal-content">
    <div class="d-flex justify-content-center my-2">
        <div class="step-indicator d-flex">
            <div class="step active">
                <div class="step-number">1</div>
                <div class="step-text">Conteo</div>
            </div>
            <div class="step-line"></div>
            <div class="step" [ngClass]="{ active: step === 'observations' }">
                <div class="step-number">2</div>
                <div class="step-text">Resultado</div>
            </div>
        </div>
    </div>

    <div class="step-panel" *ngIf="step === 'amount'">
        <div class="modal-header">
            <h2 class="modal-title">{{ getModalTitle() }}</h2>
            <p class="subtitle">{{ getModalSubtitle() }}</p>
        </div>

        <!-- Conteo por método de pago. A propósito no se muestra el monto esperado: el
             usuario cuenta a ciegas y las diferencias aparecen al confirmar el cierre. -->
        <div class="count-list p-3" *ngIf="isMultiMethod">
            <div class="count-head">
                <span class="count-head__name">Cuenta</span>
                <span class="count-head__currency">Mon.</span>
                <span class="count-head__input">Contado</span>
            </div>

            <div class="count-row" *ngFor="let row of rows">
                <div class="count-row__name">
                    <span class="count-row__title">{{ row.displayName }}</span>
                    <span class="count-row__subtitle">{{ row.bankAccountName }}</span>
                </div>
                <div class="count-row__currency">
                    <span class="currency-badge" [class.currency-badge--usd]="row.currency === 'USD'">{{ row.currency === 'USD' ? '$' : 'Bs' }}</span>
                </div>
                <div class="count-row__input">
                    <input
                        class="counted-input"
                        type="number"
                        min="0"
                        step="0.01"
                        max="9999999999.99"
                        placeholder="0,00"
                        [(ngModel)]="row.countedAmount"
                        [name]="'counted_' + row.bankAccountId"
                        (input)="validateAmount($event, row)"
                        finaBlurOnWheel
                    />
                </div>
            </div>

            <div class="count-hint" *ngIf="rows.length">
                <i class="fa fa-info-circle me-1"></i>
                Al confirmar verás la diferencia de cada método.
            </div>
        </div>

        <!-- Caja abierta antes del cambio: se cierra con el monto único en dólares. -->
        <div class="row p-3" *ngIf="!isMultiMethod">
            <div class="form-group d-flex flex-column">
                <div class="d-flex align-items-center gap-2">
                    <label for="finalAmount" class="box-text me-3"><strong>Monto final (USD):</strong></label>
                    <div class="input-group custom-width">
                        <input
                            id="finalAmount"
                            class="form-control box-input-span"
                            type="number"
                            min="0"
                            step="0.01"
                            required
                            [(ngModel)]="finalAmountUSD"
                            name="finalAmount"
                            #finalAmount="ngModel"
                            finaBlurOnWheel
                        />
                        <div *ngIf="finalAmount.invalid && (finalAmount.dirty || finalAmount.touched)">
                            <small class="text-danger" *ngIf="finalAmount.errors?.['required']">Campo requerido</small>
                            <small class="text-danger" *ngIf="finalAmount.errors?.['min']">Valor mínimo: 0</small>
                        </div>
                        <span class="currency">$</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer d-flex justify-content-end gap-2">
            <button class="btn btn-outline-secondary" (click)="cancelClose()" type="button">Cancelar</button>
            <button
                class="btn btn-primary"
                (click)="proceedToObservations()"
                type="button"
                [disabled]="loading || (isMultiMethod && hasMissingCount) || !(userService.user$ | async)?.permissions?.POS?.includes('close-cashbox')"
            >
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Cerrar caja y generar reporte
            </button>
        </div>
    </div>

    <div class="step-panel" *ngIf="step === 'observations'">
        <div class="modal-header">
            <h2 class="modal-title">Resultado del cierre</h2>
        </div>

        <div class="row p-3">
            <div *ngIf="!hasDiscrepancy" class="alert alert-success">
                <div class="d-flex align-items-center mb-2">
                    <i class="fa fa-check-circle me-2"></i>
                    <strong>Todo en orden</strong>
                </div>
                <p class="mb-0">No hubo diferencias en ningún método de pago.</p>
            </div>

            <!-- Resultado multi-método: solo diferencias, cada moneda por su lado. -->
            <ng-container *ngIf="isMultiMethod">
                <div class="result-list">
                    <div class="result-row" *ngFor="let entry of closedEntries">
                        <div class="result-row__name">
                            <span class="result-row__title">{{ entry.displayName }}</span>
                            <span class="result-row__subtitle">{{ entry.bankAccountName }}</span>
                        </div>
                        <div class="result-row__currency">
                            <span class="currency-badge" [class.currency-badge--usd]="entry.currency === 'USD'">{{ entry.currency === 'USD' ? '$' : 'Bs' }}</span>
                        </div>
                        <div class="result-row__counted">
                            <span class="result-label">Contado</span>
                            <span class="result-value">{{ entry.countedAmount | number : '1.2-2' }}</span>
                        </div>
                        <div class="result-row__difference">
                            <span class="diff-badge" [ngClass]="entry.difference === 0 ? 'diff-badge--ok' : entry.difference > 0 ? 'diff-badge--over' : 'diff-badge--short'">
                                {{ entry.difference | number : '1.2-2' }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="totals-grid">
                    <div class="total-card" *ngFor="let total of differenceTotals" [ngClass]="total.total === 0 ? 'total-card--ok' : 'total-card--alert'">
                        <span class="total-card__label">Diferencia total en {{ total.currency === 'USD' ? '$' : 'Bs' }}</span>
                        <span class="total-card__value">{{ total.total | number : '1.2-2' }} {{ total.currency === 'USD' ? '$' : 'Bs' }}</span>
                    </div>
                </div>
            </ng-container>

            <!-- Resultado del esquema anterior. -->
            <div class="card mb-3" *ngIf="!isMultiMethod">
                <div class="card-body">
                    <div class="d-flex justify-content-between mb-2">
                        <span>Monto final:</span>
                        <span>{{ closedCashbox?.finalAmountUSD | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
                    </div>
                    <div class="d-flex justify-content-between fw-bold">
                        <span>Diferencia:</span>
                        <span>{{ closedCashbox?.discrepancy | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
                    </div>
                </div>
            </div>

            <div class="form-group mb-3 mt-3">
                <label for="observaciones" class="form-label"><strong>Observaciones</strong></label>
                <textarea class="form-control" id="observaciones" name="observaciones" rows="3" placeholder="Agregue observaciones sobre el cierre de caja..." [(ngModel)]="observaciones"></textarea>
            </div>
        </div>

        <div class="modal-footer d-flex justify-content-end gap-2">
            <button class="btn btn-primary" (click)="closeCashbox()" type="button" [disabled]="loading || !(userService.user$ | async)?.permissions?.POS?.includes('close-cashbox')">
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Finalizar
            </button>
        </div>
    </div>

    <div
        id="animation-confetti"
        class="animation-container"
        [ngClass]="{ 'd-none': hasDiscrepancy || step === 'amount' }"
        style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 0; pointer-events: none"
    ></div>
</div>
